import React from 'react'
import { Tag, Tooltip } from 'antd'
import styled from 'styled-components'
import Flex from 'components/Flex'
import LinkIcon from 'components/icons/icons8-link.svg'

const CustomTagBlue = styled(Tag)`
  background-color: rgba(50, 73, 215, 1);
  border-radius: 20px;
  font-size: 10px;
  align-items: center;
  max-width: max-content;
  min-width: 32px;
`

const CustomTagBlack = styled(Tag)`
  background-color: rgba(0, 0, 0, 1);
  border-radius: 20px;
  max-width: max-content;
  min-width: 32px;
  font-size: 10px;
  height: 20px;
  align-items: center;
`
const CustomTagAsh = styled(Tag)`
  background-color: rgba(143, 143, 143, 1);
  border-radius: 20px;
  font-size: 10px;
  height: 20px;
  align-items: center;
  max-width: max-content;
  min-width: 32px;
`

const TableTag = ({ Corp, Extnl }) => (
  <Flex gap="4px" column>
    {Corp && (
       <Tooltip title="This role is floated from PluginLive">
      <CustomTagBlue color="rgba(50, 73, 215, 1)">PIL</CustomTagBlue>
      </Tooltip>
    )}
    {Extnl && 
       <Tooltip title="Role Contains External Link">
    <img src={LinkIcon} style={{ width: 'auto', height: '22px',marginBottom: "5px" }} />
    </Tooltip>}
  </Flex>
)
export default TableTag
